/**
 * Enumerator for Mqtt connection status
 */
enum MqttConnectionStatus {
	Connected = "Connected",
	Offline = "Offline",
}

export default MqttConnectionStatus;
